module.exports = __webpack_public_path__ + "img/transfer_transactions.8d3ea6d9.svg";